export default __webpack_public_path__ + "static/media/review-tan-tich-quy-am-relic-ba-the-he-va-moi-lien-ket-15965255784224.9547a923.png";